import React, { useEffect, useState } from 'react';
import { fetchHVACallOpenQuestions } from 'services/hvaqa.service';

interface CallOpenQuestionProps {
  callid: string;
  campaignid: number;
}

interface QuestionData {
  questiontext: string;
  answertext: string;
  questiondate: string;
}

export const CallOpenQuestion: React.FC<CallOpenQuestionProps> = ({
  callid,
  campaignid
}) => {
  const [questions, setQuestions] = useState<QuestionData[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Llama al servicio para obtener los datos de las scorecards no estándar
        const data = await fetchHVACallOpenQuestions({
          callid: callid,
          campaignid: campaignid
        });

        // Parsear las respuestas de la API
        // eslint-disable-next-line
        const parsedQuestions = data.map((item: any) => ({
          questiontext: item.questiontext,
          answertext: JSON.parse(item.answertext).response[0].answer, // parseando JSON
          questiondate: item.questiondate
        }));

        setQuestions(parsedQuestions);
      } catch (error) {
        console.error('Error al recuperar los datos:', error);
      }
    };

    fetchData();
  }, [callid, campaignid]);

  return (
    <>
      {questions.length > 0 && (
        <>
          <h5 className="pt-3 mb-3">Open questions</h5>
          {questions.map((question, index) => (
            <div key={index}>
              <p className="fs-9 fw-bold text-body-emphasis mb-1">
                {question.questiontext}
              </p>
              <p className="fs-10 text-primary mb-0">
                {new Date(question.questiondate).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric'
                })}
              </p>
              <p className="fs-9 text-body lh-sm mb-2">{question.answertext}</p>
            </div>
          ))}
        </>
      )}
    </>
  );
};
